/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Register several users as participants of a workshop at once.
 * @export
 * @interface WorkshopAttendanceBulkCreate
 */
export interface WorkshopAttendanceBulkCreate {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopAttendanceBulkCreate
     */
    user_ids: Array<string>;
}

/**
 * Check if a given object implements the WorkshopAttendanceBulkCreate interface.
 */
export function instanceOfWorkshopAttendanceBulkCreate(value: object): value is WorkshopAttendanceBulkCreate {
    if (!('user_ids' in value) || value['user_ids'] === undefined) return false;
    return true;
}

export function WorkshopAttendanceBulkCreateFromJSON(json: any): WorkshopAttendanceBulkCreate {
    return WorkshopAttendanceBulkCreateFromJSONTyped(json, false);
}

export function WorkshopAttendanceBulkCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceBulkCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'user_ids': json['user_ids'],
    };
}

export function WorkshopAttendanceBulkCreateToJSON(json: any): WorkshopAttendanceBulkCreate {
    return WorkshopAttendanceBulkCreateToJSONTyped(json, false);
}

export function WorkshopAttendanceBulkCreateToJSONTyped(value?: WorkshopAttendanceBulkCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_ids': value['user_ids'],
    };
}

